
import React from 'react'
import { Select, SelectProps } from 'antd';

export const PromotionType = {
  special: 'special', // 商品特价
  buy_present: 'buy_present', // 商品买赠
  group_buy: 'group_buy', // 团购活动
} 

export const PromotionTypeMap = {
  [PromotionType.special]: '商品特价',
  // Ai Start
  [PromotionType.buy_present]: '商品买赠',
  [PromotionType.group_buy]: '团购活动',
  // Ai End
}

export interface FilterPromotionTypeProps extends SelectProps {}


export const FilterPromotionType = (props: FilterPromotionTypeProps) => {
  const { placeholder = '促销类型', mode, ...reset } = props;
  const options = Object.entries(PromotionTypeMap).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={[{ label: "全部", value: '' }, ...options]}
      placeholder={placeholder}
      {...reset}
    />
  )
}